define('utils/colorizr-methods',['jquery', 'utils/colors'], function($, color) {

    var int2Float = function Bytes2Float32(bytes) {
        var sign = (bytes & 0x80000000) ? -1 : 1;
        var exponent = ((bytes >> 23) & 0xFF) - 127;
        var significand = (bytes & ~(-1 << 23));

        if (exponent == 128) 
            return sign * ((significand) ? Number.NaN : Number.POSITIVE_INFINITY);

        if (exponent == -127) {
            if (significand == 0) return sign * 0.0;
            exponent = -126;
            significand /= (1 << 22);
        } else significand = (significand | (1 << 23)) / (1 << 23);

        return sign * significand * Math.pow(2, exponent);
    };

    return {
        single_simple: function(pixel, envloss, maxOffset) {
            var margin = Math.max(0, Math.min(pixel.r / 3, maxOffset) - envloss);
            if (margin > 30) {
                return { r:255, g:0, b:0, a:255};
            } else if (margin > 20) {
                return { r:0, g:255, b:0, a:255};
            } else if (margin > 0) {
                return { r:0, g:0, b:255, a:255};
            }
            return { r:0, g:0, b:0, a: 0 };
        },
        single_detailled_margin: function(pixel, envloss, maxOffset) {
            var margin = Math.max(0, Math.min(pixel.r / 3, maxOffset) - envloss);
            if (margin > 0) {
                var result = color.HSBToRGB((2/3) * (1 - margin / maxOffset), 1, 1);
                result.a = 255;
                return result;
            }
            return { r:0, g:0, b:0, a: 0 };
        },
        single_detailled_rssi: function(pixel, maxOffset) {
            var margin = Math.min(pixel.r / 3, maxOffset);
            if (margin > 0) {
                var result = color.HSBToRGB((2/3) * (1 - margin / maxOffset), 1, 1);
                result.a = 255;
                return result;
            }
            return { r:0, g:0, b:0, a: 0 };
        },
        global_detailled_margin: function(pixel, maxOffset) {
            var margin = Math.min(pixel.r / 3, maxOffset);
            if (margin > 0) {
                var result = color.HSBToRGB((2/3) * (1 - margin / maxOffset), 1, 1);
                result.a = 255;
                return result;
            }
            return { r:0, g:0, b:0, a: 0 };
        },
        global_detailled_rssi: function(pixel, maxOffset) {
            var margin = Math.min(pixel.a / 3, maxOffset);
            if (margin > 0) {
                var result = color.HSBToRGB((2/3) * (1 - margin / maxOffset), 1, 1);
                result.a = 255;
                return result;
            }
            return { r:0, g:0, b:0, a: 0 };
        },
        operator_overlap: function(pixel, offset, maxOffset) {
            if (Math.min(pixel.b / 3, maxOffset) > offset) {
                return { r:255, g:0, b:0, a: 255 };
            } else if (Math.min(pixel.g / 3, maxOffset) > offset) {
                return { r:0, g:255, b:0, a: 255 };
            } else if (Math.min(pixel.r / 3, maxOffset) > offset) {
                return { r:0, g:0, b:255, a: 255 };
            }
            return { r:0, g:0, b:0, a: 0 };
        },
        land_cover: function(pixel) {

            function pixelColorEq(a) {
                return a.r === pixel.r && a.g === pixel.g && a.b === pixel.b && a.a === pixel.a;
            }

            var legacyColors = [
                {r: 0x00, g: 0x00, b: 0x00, a: 0x00},
                {r: 0x00, g: 0x1e, b: 0x46, a: 0xff},
                {r: 0x10, g: 0x6d, b: 0x10, a: 0xff},
                {r: 0x01, g: 0x82, b: 0x00, a: 0xff},
                {r: 0x97, g: 0xbf, b: 0x47, a: 0xff},
                {r: 0x02, g: 0xdc, b: 0x00, a: 0xff},
                {r: 0x00, g: 0xff, b: 0x00, a: 0xff},
                {r: 0x92, g: 0xae, b: 0x2f, a: 0xff},
                {r: 0xdc, g: 0xce, b: 0x00, a: 0xff},
                {r: 0xff, g: 0xad, b: 0x00, a: 0xff},
                {r: 0xff, g: 0xfb, b: 0xc3, a: 0xff},
                {r: 0x8c, g: 0x48, b: 0x09, a: 0xff},
                {r: 0xf7, g: 0xa5, b: 0xff, a: 0xff},
                {r: 0xff, g: 0xc7, b: 0xae, a: 0xff},
                {r: 0x00, g: 0xff, b: 0xff, a: 0xff},
                {r: 0x00, g: 0xaa, b: 0xaa, a: 0xff}
            ];


            /*
1 	Water 	4292c6
2 	Barren 	e5f5f9
3 	Low vegetation 	99d8c9
4 	Sparse Forest 	41ae76
5 	Forest 	006d2c
6 	Commercial/industrial 	969696
7 	Open 	d9d9d9
8 	Village 	e7e1ef
9 	Residential with trees 	d4b9da
10 	Residential with few trees 	c994cf
11 	Dense Residential 	df65b0
12 	Building blocks 	e7298a
13 	High buildings 	ce1256
14 	Urban 	980043
15 	Dense Urban 	67001f
             */


            var newColors = [
                {r: 0, g: 0, b: 0, a: 0},
                {r: 0x42, g: 0x92, b: 0xc6, a: 0xFF},
                {r: 0xe5, g: 0xf5, b: 0xf9, a: 0xFF},
                {r: 0x99, g: 0xd8, b: 0xc9, a: 0xFF},
                {r: 0x41, g: 0xae, b: 0x76, a: 0xFF},
                {r: 0x00, g: 0x6d, b: 0x2c, a: 0xFF},
                {r: 0x96, g: 0x96, b: 0x96, a: 0xFF},
                {r: 0xd9, g: 0xd9, b: 0xd9, a: 0xFF},
                {r: 0xe7, g: 0xe1, b: 0xef, a: 0xFF},
                {r: 0xd4, g: 0xb9, b: 0xda, a: 0xFF},
                {r: 0xc9, g: 0x94, b: 0xcf, a: 0xFF},
                {r: 0xdf, g: 0x65, b: 0xb0, a: 0xFF},
                {r: 0xe7, g: 0x29, b: 0x8a, a: 0xFF},
                {r: 0xce, g: 0x12, b: 0x56, a: 0xFF},
                {r: 0x98, g: 0x00, b: 0x43, a: 0xFF},
                {r: 0x67, g: 0x00, b: 0x1f, a: 0xFF}
            ];

            // Depending on the pixel, find the index of the new color to apply.
            // TODO check if findIndex is ok with legacy browser support.
            var index = Math.max(legacyColors.findIndex(pixelColorEq), 0);
            return newColors[index];
        },
        density: function(pixel, colorSteps) {
            var bytes = ((pixel.a << 24) & 0xFF000000) || ((pixel.r << 16) & 0xFF0000) || ((pixel.g << 8) & 0xFF00) || (pixel.b & 0xFF);
            var densityValue = int2Float(bytes);
            if (densityValue > colorSteps[5]) {
                return { r:255, g:0, b:255, a: 255 };
            } else if (densityValue > colorSteps[4]) {
                return { r:255, g:0, b:0, a: 255 };
            } else if (densityValue > colorSteps[3]) {
                return { r:255, g:255, b:0, a: 255 };
            } else if (densityValue > colorSteps[2]) {
                return { r:0, g:255, b:0, a: 255 };
            } else if (densityValue > colorSteps[1]) {
                return { r:0, g:255, b:255, a: 255 };
            } else if (densityValue > colorSteps[0]) {
                return { r:0, g:0, b:255, a: 255 };
            }
            return { r:0, g:0, b:0, a: 0 };
        },
        progress: function(pixel, popPixel, maxOffset, targets, colorSteps) {
            var bytes = ((popPixel.a << 24) & 0xFF000000) || ((popPixel.r << 16) & 0xFF0000) || ((popPixel.g << 8) & 0xFF00) || (popPixel.b & 0xFF);
            var popValue = int2Float(bytes);
            var step = 0;
            while (step < colorSteps.length && popValue > colorSteps[step]) {
                step++;
            }
            var margin1 = targets[step].margin1 + 1;
            var margin2 = targets[step].margin2 + 1;
            var margin3 = targets[step].margin3 + 1;
            var base = margin1 + margin2 + margin3;
            var pixel1 = Math.min(pixel.r / 3, maxOffset);
            var pixel2 = Math.min(pixel.g / 3, maxOffset);
            var pixel3 = Math.min(pixel.b / 3, maxOffset);
            var value1 = pixel1 != 0 ? pixel1 + 1 : 0;
            var value2 = pixel2 != 0 ? pixel2 + 1 : 0;
            var value3 = pixel3 != 0 ? pixel3 + 1 : 0;
            var note = Math.min(margin1, value1) + Math.min(margin2, value2) + Math.min(margin3, value3);
            if (base == 0 || note / base > 0.995) {
                return { r:0, g:0, b:255, a: 255 };
            }
            var total = note / (3 * base);
            var result = color.HSBToRGB(total, 1, 1);
            result.a = 255;
            return result;
        },
        simple_progress: function(pixel) {
            if (pixel.r == 0) {
                return { r:0, g:0, b:0, a: 0 };
            }
            var total = (pixel.r - 1) / 200;
            if (total > 0.995) {
                return { r:0, g:0, b:255, a: 255 };
            }
            var result = color.HSBToRGB(2 * total / 3, 1, 1);
            result.a = 255;
            return result;
        },
        device_location_detailled: function(pixels, rssis, upperRange, lowerRange, maxOverlap, minDb) {
            var count = 0;
            var exist = 0;
            for (var i in pixels) {
                if (pixels[i].r / 3 > 0) {
                    exist++;
                    var diff = pixels[i].r / 3 - (rssis[i] - minDb);
                    if (diff <= upperRange && diff > lowerRange) {
                        count++;
                    }
                }
            }
            if (exist != maxOverlap) {
                return { r:0, g:0, b:0, a: 0 };
            } else {
                var total = (2/3) * (1 - count / maxOverlap);
                var result = color.HSBToRGB(total, 1, 1);
                result.a = 255;
                return result;
            }
        },
        device_location_simple: function(pixels) {
            var exist = true;
            for (var i in pixels) {
                if (pixels[i].r / 3 <= 0) {
                    exist = false;
                }
            }
            if (!exist) {
                return { r:0, g:0, b:0, a: 0 };
            } else {
                return { r:0, g:0, b:255, a: 255 };
            }
        }
    };
});

